import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Division, Language } from '../../shared/model';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css', '../../shared/styles/translation.css']
})
export class BannerComponent implements OnInit {

  @Input() active: boolean;
  @Input() selectedLanguage: Language;
  
  @Output() disable: EventEmitter<BannerComponent> = new EventEmitter();
  @Output() enable: EventEmitter<BannerComponent> = new EventEmitter();
  
  imageSrc: string = "../../../assets/icons/meetelisaExpert1.svg";
  randomNum: number;
  shouldShowSupportInformation: boolean;

  constructor(private sharedService: SharedService) { 
  }

  ngOnInit() {
    this.sharedService.getUserDetails().subscribe(
      data => {
        if (data.Division == Division.ThermalEurope) {
          this.shouldShowSupportInformation = true;
        }
      }
    );

    this.randomNum = Math.floor(Math.random() * (4));

    switch(this.randomNum)
    {
      case 0:
        this.imageSrc = "../../../assets/icons/meetelisaExpert1.svg";
        break;
      case 1:
        this.imageSrc = "../../../assets/icons/meetelisaExpert2.svg";
        break;
      case 2:
        this.imageSrc = "../../../assets/icons/meetelisaExpert3.svg";
        break;
      default:
        this.imageSrc = "../../../assets/icons/meetelisaExpert4.svg";
        break; 
    }
  }

  disableBanner()
  {
    this.disable.emit();
  }
  enableBanner()
  {
    this.enable.emit();
  }

}
